import { combineReducers } from "redux"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

import dataFormulaireReducer from "./containers/DisplayForm/reducer"
import dataGovernanceReducer from "./containers/Activity/reducer"
import riskDataReducer from "./containers/Risks/reducer"
import controlPlanReducer from "./containers/ControlPlans/reducer"
import dataDocumentManagementReducer from "./containers/DocumentManagement/reducer"
import actionPlanReducer from "./containers/ActionPlan/reducer"
import recommendationsReducer from "./containers/Recommendations/reducer"
import mappingRiskReducer from "ContainersForm/MappingRisk/reducer"
import nonConformitiesReducer from "ContainersForm/NonConformity/reducer"
import customListsReducer from "ContainersForm/CustomLists/reducer.js"
import dataAuditPlansReducer from "ContainersForm/AuditPlans/reducer.js"
import customSkeletonsReducer from "ContainersForm/CustomSkeletons/reducer.js"

// Persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: [],
  blacklist: [],
}

const rootReducer = combineReducers({
  actionPlan: actionPlanReducer,
  dataAuditPlans: dataAuditPlansReducer,
  dataFormulaire: dataFormulaireReducer,
  dataGovernance: dataGovernanceReducer,
  dataRisk: riskDataReducer,
  dataPlanOfControl: controlPlanReducer,
  dataDocumentManagement: dataDocumentManagementReducer,
  dataRecommendations: recommendationsReducer,
  mappingRisk: mappingRiskReducer,
  nonConformities: nonConformitiesReducer,
  customLists: customListsReducer,
  customSkeletons: customSkeletonsReducer,
})

export default persistReducer(persistConfig, rootReducer)
